import { render, staticRenderFns } from "./ReorderTables.vue?vue&type=template&id=6433db7e"
import script from "./ReorderTables.vue?vue&type=script&lang=js"
export * from "./ReorderTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports